import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
// import moment from "moment";
// import small from "../images/small.png";
// import { Markup } from "interweave";
import SideBar from "../SideBar/SideBar";
import axiosApiInstance from "../axios";
import AllTicketsHeader from "../AllTickets/AllTicketsHeader";
import "./KnowledgeBase.css";
// import { LinearProgress } from "@material-ui/core";
import { Button } from "@mui/material";

import Grid from "@mui/material/Grid";
import AllArticle from "../AllArticle/AllArticle";
import _ from "lodash";

const KnowledgeBase = ({ fetchedRole }) => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [term, setTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadNew, setLoadNew] = useState(true);
  const [show, setShow] = useState(false);

  const [categoryName, setCategoryName] = useState("");
  const [isActive, setIsActive] = useState();
  const [dataSearch, setDataSearch] = useState({});
  const [searchedItem, setSearchedItem] = useState([]);

  const [category, setCategory] = useState([]);

  useEffect(() => {
    axiosApiInstance.get("/category").then((res) => {
      res.data.data.push({id: 0, name: 'All', description: 'All', isActive: true});
      setCategory(res.data.data);
    });
  }, []);

  let clicks = [];
  let timeout;

  const handleCategory = (name) => {
    // setChangeState(true);
    setCategoryName(name);
    setIsActive(name);
  };
  function clickHandler(event) {
    clicks.push(new Date().getTime());
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => {
      if (
        clicks.length > 1 &&
        clicks[clicks.length - 1] - clicks[clicks.length - 2] < 250
      ) {
        handleDoubleCategory(event);
      } else {
        handleCategory(event);
      }
    }, 250);
  }

  const handleDoubleCategory = () => {
    setCategoryName("");
    setIsActive();
  };

  const searchHandler = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const searchArticle = _.debounce((e) => {
    if (e.target.value !== "") {
      setDataSearch(e.target.value);
    } else {
      setSearchedItem([]);
    }
  }, 500);

  const searchButton = () => {
    if (dataSearch) {
      setTimeout(() => {
        axiosApiInstance
          .get(`/article/GetArticlesBasedOnSearch?data=${dataSearch}`)
          .then((response) => {
            if (response.data.succeeded) {
              setSearchedItem(response.data.data);
            } else {
              setSearchedItem([]);
            }
          })
          .catch((err) => console.log(err));
      }, 800);
    }
  };


  return (
    <>
      <AllTicketsHeader searchKeyword={searchHandler} term={searchTerm} />
      <SideBar />
      <div className="k-all-base">
        <div className="k-base">
          {/* <Grid container>
            <Grid item xs={6} md={9.6}> */}
            <div className="K-base-searchbar">
              <div className="k-search-bar">
                <div className="k-search">
                  <input
                    type="text"
                    placeholder="Search for Articles"
                    onChange={searchArticle}
                  />
                </div>
                <div className="k-search-button">
                  <Button onClick={searchButton}>Search</Button>
                </div>
              </div>
            {/* </Grid> */}

            {/* <Grid item xs={6} md={2.4}> */}
              <div className="K-create-article">
                <div className="k-title">
                  <Button onClick={() => navigate("/add")}>
                    <p>+</p>Create Article
                  </Button>
                </div>
              </div>
              </div>
            {/* </Grid> */}
          {/* </Grid> */}

          <div className="k-category-container">
            {category.map((catg, indx) => (
              <span
                className={
                  isActive === catg.name
                    ? "k-category-item-active"
                    : "k-category-item"
                }
                key={indx}
                onClick={() => clickHandler(catg.name)}
              >
                {catg.name}
              </span>
            ))}
          </div>

          <AllArticle
            term={term}
            categoryName={categoryName}
            fetchedRole={fetchedRole}
            searchedItem={searchedItem}
          ></AllArticle>
        </div>
      </div>
    </>
  );
};

export default KnowledgeBase;
